import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { UserInfo } from 'firebase/app';
import * as firebase from 'firebase';
import { Constants } from '../config/Constants';
@Injectable()
export class UtilityService {

  constructor(private angularFireAuth:AngularFireAuth) {
  }

  public isLogged():boolean{
    if(Storage && localStorage.getItem("userData")){
        return true;
    }else{
      return false;
    }
  }

  public setUser(user){
    console.log("123");
    console.log(user);
    localStorage.setItem("userData",JSON.stringify(user));
  }

  public logout(){
    if(Storage && localStorage.getItem("userData")){
      return localStorage.removeItem("userData");
    }else{
      return null;
    }
  }

  public getUserData():any{
    if(Storage && localStorage.getItem("userData")){
      return JSON.parse(localStorage.getItem("userData"));
    }else{
      return null;
    }
  }
  public getUserEmail():string{
    if(Storage && localStorage.getItem("userData")){
      return JSON.parse(localStorage.getItem("userData")).email;
    }else{
      return null;
    }
  }
  public getUserUID():string{
    if(Storage && localStorage.getItem("userData")){
      return JSON.parse(localStorage.getItem("userData")).uid;
    }else{
      return null;
    }
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/services/utility.service.ts